"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Exports that only provide a single mock object
 */
var mockCoverageCatalogList_1 = require("./mockCoverageCatalogList");
Object.defineProperty(exports, "mockCoverageCatalogList", { enumerable: true, get: function () { return mockCoverageCatalogList_1.default; } });
var mockCoverageCatalogResumeList_1 = require("./mockCoverageCatalogResumeList");
Object.defineProperty(exports, "mockCoverageCatalogResumeList", { enumerable: true, get: function () { return mockCoverageCatalogResumeList_1.default; } });
var mockCustomer_1 = require("./mockCustomer");
Object.defineProperty(exports, "mockCustomer", { enumerable: true, get: function () { return mockCustomer_1.default; } });
var mockLegalEntity_1 = require("./mockLegalEntity");
Object.defineProperty(exports, "mockLegalEntity", { enumerable: true, get: function () { return mockLegalEntity_1.default; } });
var mockDriver_1 = require("./mockDriver");
Object.defineProperty(exports, "mockDriver", { enumerable: true, get: function () { return mockDriver_1.default; } });
var mockProductConfiguration_1 = require("./mockProductConfiguration");
Object.defineProperty(exports, "mockProductConfiguration", { enumerable: true, get: function () { return mockProductConfiguration_1.default; } });
var mockQuotationCoverageList_1 = require("./mockQuotationCoverageList");
Object.defineProperty(exports, "mockQuotationCoverageList", { enumerable: true, get: function () { return mockQuotationCoverageList_1.default; } });
var mockSpecialCoverageCatalog_1 = require("./mockSpecialCoverageCatalog");
Object.defineProperty(exports, "mockSpecialCoverageCatalog", { enumerable: true, get: function () { return mockSpecialCoverageCatalog_1.default; } });
var mockUnitPackage_1 = require("./mockUnitPackage");
Object.defineProperty(exports, "mockUnitPackage", { enumerable: true, get: function () { return mockUnitPackage_1.default; } });
var mockVehicle_1 = require("./mockVehicle");
Object.defineProperty(exports, "mockVehicle", { enumerable: true, get: function () { return mockVehicle_1.default; } });
var mockProductCoverageCatalog_1 = require("./mockProductCoverageCatalog");
Object.defineProperty(exports, "mockProductCoverageCatalog", { enumerable: true, get: function () { return mockProductCoverageCatalog_1.default; } });
var mockPolicyCarData_1 = require("./mockPolicyCarData");
Object.defineProperty(exports, "mockPolicyCarData", { enumerable: true, get: function () { return mockPolicyCarData_1.default; } });
var mockPolicyCertificate_1 = require("./mockPolicyCertificate");
Object.defineProperty(exports, "mockPolicyCertificate", { enumerable: true, get: function () { return mockPolicyCertificate_1.default; } });
var mockCarPolicy_1 = require("./mockCarPolicy");
Object.defineProperty(exports, "mockCarPolicy", { enumerable: true, get: function () { return mockCarPolicy_1.default; } });
/**
 * Exports that provide multiple mock objects
 */
exports.mockQuotations = __importStar(require("./mockQuotations"));
exports.mockQuotationStatus = __importStar(require("./mockQuotationStatus"));
exports.mockQuotationSummaries = __importStar(require("./mockQuotationSummaries"));
exports.mockUnits = __importStar(require("./mockUnits"));
exports.mockCoverages = __importStar(require("./mockCoverages"));
exports.mockDiscounts = __importStar(require("./mockDiscounts"));
exports.mockTotal = __importStar(require("./mockTotal"));
exports.mockPdfDownloader = __importStar(require("./mockPdfDownloaderResult"));
exports.mockDynamicRenderConfig = __importStar(require("./mockDynamicRenderConfig"));
exports.catalogs = __importStar(require("./catalogs"));
//# sourceMappingURL=index.js.map